import { render, staticRenderFns } from "./WordpressSlider.vue?vue&type=template&id=d0c5932e"
import script from "./WordpressSlider.vue?vue&type=script&lang=js"
export * from "./WordpressSlider.vue?vue&type=script&lang=js"
import style0 from "./WordpressSlider.vue?vue&type=style&index=0&id=d0c5932e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports